import { ACTIVITY_TYPE } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

const constructPayloadSubmit = (data = {}) => {
  const mapUnit = (item) => ({
    id: item?.id || null,
    unitStockId: item?.unitStockId || null,
    kodeVariant: item?.kodeVariant?.value || null,
    idWarna: item?.namaWarna?.value || null,
    stockDays: item?.stockDays || null,
  });

  const mapPart = (item) => ({
    id: item?.id || null,
    partStockId: item?.partStockId || null,
    partCode: item?.partCode?.value || null,
    stockDays: item?.stockDays || null,
  });

  return {
    id: data?.id || null,
    wilayahCode: data.wilayahCode?.value || null,
    documentId: data?.documentId || null,
    unit: data?.dataUnit?.length > 0 ? data.dataUnit.map(mapUnit) : [],
    part: data?.dataPart?.length > 0 ? data.dataPart.map(mapPart) : [],
  };
};

const constructGetData = (data, activityType) => {
  const isCopy = activityType === ACTIVITY_TYPE.COPY;
  const { unit = [], part = [], wilayahCode, ...rest } = data;

  const mapUnit = (item) => {
    const { variant, warna } = item || {};
    return {
      id: item?.id,
      unitStockId: item?.unitStockId,
      namaVariant: mapToObjectDDL(variant?.namaVariant, variant?.kodeVariant),
      kodeVariant: mapToObjectDDL(variant?.kodeVariant, variant?.kodeVariant),
      kodeWarna: mapToObjectDDL(warna?.kodeWarna, warna?.id),
      namaWarna: mapToObjectDDL(warna?.namaWarnaPabrik, warna?.id),
      stockDays: item?.stockDays,
      isSaved: true,
    };
  };

  const mapPart = (item) => {
    const { part } = item;
    return {
      id: item?.id,
      partStockId: item?.partStockId,
      partCode: mapToObjectDDL(part?.kodePart, part?.kodePart),
      namaPart: mapToObjectDDL(part?.partName, part?.kodePart),
      stockDays: item?.stockDays,
      isSaved: true,
    };
  };

  return {
    ...rest,
    wilayahCode: isCopy
      ? null
      : mapToObjectDDL(wilayahCode?.value, wilayahCode?.key),
    dataUnit: unit.map(mapUnit),
    dataPart: part.map(mapPart),
  };
};

const validateAcuanStockData = (data) => {
  const wilayahValid = !!data?.wilayahCode?.value;

  const unitValid = (data?.dataUnit || []).every((u) =>
    u?.namaVariant?.value &&
    u?.kodeVariant?.value &&
    u?.namaWarna?.value &&
    u?.kodeWarna?.value &&
    u?.stockDays != null &&
    u?.isSaved
  );

  const partValid = (data?.dataPart || []).every((p) =>
    p?.partCode &&
    p?.namaPart &&
    p?.stockDays != null &&
    p?.isSaved
  );

  return {
    isValid: unitValid && partValid,
    wilayahValid,
    isDataTableExist: !!(data?.dataUnit?.length || data?.dataPart?.length)
  };
};




const validateRow = (row, type) => {
  if (type === "unit") {
    return {
      namaVariant: row?.namaVariant?.value ? null : "Field wajib diisi.",
      kodeVariant: row?.kodeVariant?.value ? null : "Field wajib diisi.",
      namaWarna: row?.namaWarna?.value ? null : "Field wajib diisi.",
      kodeWarna: row?.kodeWarna?.value ? null : "Field wajib diisi.",
      stockDays: row?.stockDays != null ? null : "Field wajib diisi.",
    };
  }

  if (type === "part") {
    return {
      partCode: row?.partCode ? null : "Field wajib diisi.",
      namaPart: row?.namaPart ? null : "Field wajib diisi.",
      stockDays: row?.stockDays != null ? null : "Field wajib diisi.",
    };
  }

  return {};
};

export default {
  constructPayloadSubmit,
  constructGetData,
  validateAcuanStockData,
  validateRow
};
